module.exports = __webpack_public_path__ + "img/default.3e9afa2c.png";